export default __webpack_public_path__ + "static/media/EmergencyTreeWorks.469d497c.jpg";